import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";

interface CardProps {
    title?: string | React.FC;
    cardStyles?: React.CSSProperties;
    width?: number;
    height?: number;
    borderRadius?: number;
    gap?: number;
}

const Card: React.FC<CardProps> = ({ title, children, cardStyles, width, height, borderRadius, gap }) => {
    const radius = borderRadius || 20;

    return (
        <Stack
            gap={gap}
            style={{
                borderRadius: radius,
                boxShadow: "0px 3px 5px 0px rgba(122, 122, 125, 0.15)",
                width,
                height,
                ...cardStyles,
                background: colors.background,
            }}
        >
            {title ? (
                <Group
                    align="center"
                    style={{
                        borderRadius: `${radius}px ${radius}px 0 0`,
                        borderBottom: `1px solid ${colors.border}`,
                        background: colors.accent,
                        height: 48,
                        padding: "6px 20px",
                    }}
                >
                    {typeof title === "string" ? (
                        <Typography color={colors.textAccent} size={16} weight={700} lineHeight="18px">
                            {title}
                        </Typography>
                    ) : (
                        title
                    )}
                </Group>
            ) : (
                <></>
            )}
            {children}
        </Stack>
    );
};

export default Card;
